import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { BopScreenComponent } from '../../../components/screens/signup-process/bop-screen/bop-screen.component';
import { PolicyErrorSvgComponent } from '../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, PolicyErrorSvgComponent, BopScreenComponent, MapfreButtonComponent],
  selector: 'app-bop',
  templateUrl: './bop.component.html',
})
export class BopComponent {
  constructor(private location: Location) {}


  goBackAPage(): void {
    this.location.back();
  }
}
